import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 3,
			width: 14,
			height: 2,
			fill: "#FAFAE5",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 7,
			width: 14,
			height: 2,
			fill: "#FAFAE5",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 11,
			width: 14,
			height: 2,
			fill: "#FAFAE5",
			fillOpacity: .5
		})
	]
});
export { SvgHamburger as ReactComponent };
